import React, { useEffect, useState, useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import usePushNotifications from '../../hooks/usePushNotifications';
import { AuthContext } from '../../context/Auth/AuthContext';

const PushNotificationPrompt = () => {
  // ✅ TODOS os hooks DEVEM ser chamados ANTES de qualquer return condicional
  const authContext = useContext(AuthContext);
  const { isSupported, permission, isRegistered, requestPermission, registerPushSubscription } = usePushNotifications();
  const [open, setOpen] = useState(false);
  const [hasAsked, setHasAsked] = useState(false);
  
  // Extrair user do contexto (pode ser undefined)
  const user = authContext?.user;

  useEffect(() => {
    // Verificar se o contexto está disponível
    if (!authContext || !user) {
      return;
    }

    // Verificar se já perguntou antes (usando localStorage)
    const askedBefore = localStorage.getItem('push-notification-asked');
    setHasAsked(askedBefore === 'true');

    // Se usuário está logado, push é suportado, permissão não foi concedida e ainda não perguntou
    if (user?.id && isSupported && permission === 'default' && !hasAsked && !askedBefore) {
      // Aguardar 5 segundos após login para não ser intrusivo
      const timer = setTimeout(() => {
        setOpen(true);
      }, 5000);

      return () => clearTimeout(timer);
    }

    // Se permissão já foi concedida mas não está registrada, tentar registrar automaticamente
    if (user?.id && isSupported && permission === 'granted' && !isRegistered) {
      // Aguardar um pouco para garantir que service worker está pronto
      const timer = setTimeout(() => {
        registerPushSubscription().catch(console.error);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [authContext, user?.id, isSupported, permission, hasAsked, isRegistered, registerPushSubscription]);

  const handleAllow = async () => {
    const success = await requestPermission();
    if (success) {
      localStorage.setItem('push-notification-asked', 'true');
      setOpen(false);
    }
  };

  const handleDismiss = () => {
    localStorage.setItem('push-notification-asked', 'true');
    setOpen(false);
  };

  // Verificações finais (DEPOIS de todos os hooks)
  if (!authContext || !user || !isSupported || permission === 'granted' || hasAsked) {
    return null;
  }

  return (
    <Dialog open={open} onClose={handleDismiss}>
      <DialogTitle>
        🔔 Receber Notificações
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Permita notificações para receber alertas mesmo quando o app estiver fechado, 
          como novas mensagens, tickets e atualizações importantes.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss} color="secondary">
          Agora não
        </Button>
        <Button onClick={handleAllow} color="primary" variant="contained">
          Permitir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PushNotificationPrompt;

